export default class UserDto {
    /**
     * Construct from a UserDetails object. Note that UserDetails may be a human or device user, but this DTO
     * class is only designed for human users. (It has no systemId and no password.)
     *
     * @param userDetails The source object.
     */
    constructor(userDetails) {
        this.roleNames = [];
        this.userId = userDetails.userId;
        this.username = userDetails.username;
        this.firstName = userDetails.firstName;
        this.lastName = userDetails.lastName;
        this.enabled = true; // Always true for now. Change this if we eventually support disabling users.
        this.roleNames = userDetails.roles.map((r) => r.roleName);
    }
    toJSON() {
        const jsonObj = Object.assign({}, this);
        jsonObj.userId = this.userId;
        jsonObj.username = this.username;
        jsonObj.firstName = this.firstName;
        jsonObj.lastName = this.lastName;
        jsonObj.enabled = this.enabled;
        jsonObj.roleNames = this.roleNames;
        return jsonObj;
    }
}
//# sourceMappingURL=UserDto.js.map